<template>
    <div class="container">
        <div v-if="loaded">
            <div v-if="!error">
                <app-logo :title="title" />
                <app-step :step="step" :labels="labels" v-if="from.name != 'Multiversity'" />
                <div class="row">
                    <div class="col-md-8">
                        <form-cdl-dipendente v-if="from.name == 'Dipendente' && category == 'CDL'" :step="step" @update="updateStep" />
                        <form-oc-dipendente v-else-if="from.name == 'Dipendente' && category == 'OC'" :step="step" @update="updateStep" />
                        <form-multiversity v-else-if="from.name == 'Multiversity'" :step="1" />
                        <form-oc 
                            :course="course"
                            :step="step"
                            @update="updateStep"
                            v-else-if="category == 'OC'"> 
                        </form-oc>
                        <form-cdl 
                            :step="step"
                            :course="course"
                            @update="updateStep"
                            v-else-if="category == 'CDL'">
                        </form-cdl>
                        <form-ic 
                            :step="step"
                            :course="course"
                            @update="updateStep"
                            v-else-if="category == 'IC'">
                        </form-ic>
                    </div>
                    <div class="col-md-4 mt-3 mt-md-0">
                        <app-summary v-if="from.name != 'Multiversity'" />
                        <app-rate v-else />
                    </div>
                </div>
                <app-footer v-if="from.name != 'Multiversity'" />
                <app-costi v-else />
            </div> 
            <div v-else>
                <div class="alert alert-danger my-5 w-50 mx-auto text-center">
                    <h5>Impossibile proseguire</h5>
                    <p class="mb-0">{{ error }}</p>
                </div>
            </div>
        </div>
        <div v-else> 
            <app-loading />
        </div>
    </div>
</template>

<script>
    import AppLogo from './components/ui/AppLogo'
    import AppStep from './components/ui/AppStep'
    import AppFooter from './components/ui/AppFooter'
    import AppLoading from './components/ui/AppLoading'
    import FormCdl from './components/form/FormCdl'
    import FormCdlDipendente from './components/form/Dipendenti/FormCdlDipendente'
    import FormOc from './components/form/FormOc'
    import FormIc from './components/form/FormIc'
    import FormOcDipendente from './components/form/Dipendenti/FormOcDipendente'
    import FormMultiversity from './components/form/FormMultiversity'
    import AppSummary from './components/ui/AppSummary'
    import AppRate from './components/ui/AppRate'
    import AppCosti from './components/ui/AppCosti'
    import cookieconsent from './mixins/cookieconsent'
    import * as services from './services';
    import {mapGetters} from 'vuex'

    export default {
        components: {
            AppLogo,
            AppStep,
            AppFooter,
            AppLoading,
            FormCdl,
            FormCdlDipendente,
            FormOc,
            FormIc,
            FormOcDipendente,
            AppSummary,
            FormMultiversity,
            AppRate,
            AppCosti
        },
        data() {
            return {
                step: 1,
                labels: [
                    'Calcolo Retta',
                    'Dati Anagrafici',
                    'Recapiti',
                    'Area Personale'
                ],
                title: null,
                course: null,
                loaded: false,
                error: false
            }
        },
        mixins: [cookieconsent],
        computed: {
            ...mapGetters({
                category: 'settings/category',
                course_code: 'settings/course_code',
                token: 'settings/token',
                aa: 'settings/aa',
                from: 'settings/from'
            }), 
        },
        methods: {
            updateStep(step) {
                this.step = step
            },
            async getCdlCourse() {
                this.$store.dispatch('summary/setCategory', 'Corso di Laurea')
                if (this.course_code) {
                    try {
                        const data = await services.ecp.post('api/get/graduate/courses');
                        const course = data.data.filter(el => el.code == this.course_code)
                        if (course.length > 0) {
                            this.course = course[0]
                            this.title = this.course.name
                            this.error = false
                        } else {
                            this.error = 'Il corso selezionato non esiste!'
                        }
                    } catch(error) {
                        this.error = 'Errore di risposta dal server, riprova più tardi.'
                        console.log(error)
                    }
                } else {
                    this.title = 'Corsi di Laurea'
                    this.error = false
                }
            },
            async getOcCourse() {
                if (this.course_code) {
                    try {
                        const data = await services.ecp.get(`api/get/oc/course/${this.course_code}`)
                        if (data.data) {
                            this.course = data.data
                            this.title = this.course.title
                            this.$store.dispatch('summary/setCategory', this.course.description)
                            this.error = false
                        } else {
                            this.error = 'Il corso selezionato non esiste!'
                        }
                    } catch(error) {
                        this.error = 'Errore di risposta dal server, riprova più tardi.'
                        console.log(error)
                    }
                } else {
                    this.title = 'Corsi Post-laurea/Post-diploma'
                    this.error = false
                }
            },
            async getCourse() {
                switch (this.category) {
                    case 'CDL':
                        await this.getCdlCourse()
                        break 
                    case 'OC':
                        await this.getOcCourse()
                        break 
                    case 'IC':
                        this.title = 'Esami Singoli'
                        this.$store.dispatch('summary/setCategory', 'Esami Singoli')
                        break
                }
            },
            
        },
        async mounted() {
            if (this.from.name != 'Multiversity') {
                document.body.classList.add('bg-light');
            }
            await this.getCourse()
            this.loaded = true
            console.log('Mounted App')
        }
    }
</script>

<style>
    .vs--disabled .vs__clear, 
    .vs--disabled .vs__dropdown-toggle, 
    .vs--disabled .vs__open-indicator, 
    .vs--disabled .vs__search, 
    .vs--disabled .vs__selected {
        background-color:#e9ecef!important;
        color:#6c757d!important;
        opacity: 0.7;
    }

    .vs--disabled .vs__dropdown-toggle {
        border:1px solid #ced4da!important;
    }
</style>